import { MessageCircle, Phone } from "lucide-react";
import { buildWhatsAppUrl, callUrl } from "@/lib/config";

export default function FloatingActions() {
  return (
    <>
      <a
        href={buildWhatsAppUrl()}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="Chat with a Move Specialist"
        className="fixed bottom-6 right-6 z-50 inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white pl-4 pr-5 py-3 rounded-full shadow-2xl shadow-green-500/30 transition-transform hover:scale-[1.03] animate-pulse-ring"
      >
        <MessageCircle className="w-5 h-5" />
        <span className="hidden sm:inline text-sm font-semibold whitespace-nowrap">Chat with a Move Specialist</span>
      </a>
      <a
        href={callUrl}
        data-testid="floating-call-btn"
        aria-label="Call a Move Specialist"
        className="fixed bottom-24 right-6 z-50 bg-[#081537] hover:bg-[#0F2152] text-white p-4 rounded-full shadow-2xl shadow-blue-900/30 md:hidden transition-transform hover:scale-110"
      >
        <Phone className="w-6 h-6" />
      </a>
    </>
  );
}
